import { useTranslation } from 'react-i18next'
import { LinkBtn } from '../../../components/Buttons'
import { useZoomContext } from '../../../context/ZoomContext'
import ZoomVideo from '@zoom/videosdk'

export const CloseMeeting = () => {
    const onClose = () => {
        ZoomVideo.destroyClient()
        window.close()
    }

    const { t } = useTranslation('postmeeting')
    return <LinkBtn onClick={() => onClose()}>{t('leaveMeeting')}</LinkBtn>
}
